import { createUseStyles } from 'react-jss';

import { mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      maxWidth: '664px',
      margin: 'auto',
      marginBottom: 80,
      height: '90%',
      [mediaQuery(breakpoints.tablet)]: {
        padding: '0px 24px',
        marginBottom: 60,
      },
    },
  }),
  {
    name: 'questions-content',
  },
);

export default useStyles;
